<script>
	import Country from '$lib/Components/Forms/Country/Country.svelte';
	import SuperForm from '$lib/Components/Forms/SuperForm/SuperForm.svelte';
	import SuperInput from '$lib/Components/Forms/SuperInput/SuperInput.svelte';
	import leadSchema from '$lib/PageSections/Forms/schemas/lead.schema.js';

	let {
		data = null,
		form = null,
		disabled = null,
		class: className = '',
		leadFormData = $bindable(),
		buttonText = 'Submit',
		action = '/forms/lead-commercial',
		text,
	} = $props();
</script>

<div>
	<p class="col-span-full mb-4 p-0 text-left text-sm text-indow-grey-dark!">
		{#if text}{@render text()}{:else}
			<span>
				Enter your information and our Commercial sales team will be in touch to
				answer any questions you have and prepare an initial estimate for you.
			</span>
		{/if}
	</p>

	<SuperForm
		{data}
		initialFormData={form?.leadForm ?? data?.forms?.leadForm}
		{disabled}
		{buttonText}
		formName="leadCommercial"
		method="POST"
		sendPixelEvents
		schema={leadSchema}
		bind:innerForm={leadFormData}
		{action}
		buttonCenter
		class={className}
		defaultValues={{ country: 'United States' }}
	>
		{#snippet children({ form, disabled })}
			<SuperInput
				{form}
				{disabled}
				name="firstName"
				label="First Name"
				autocomplete="given-name"
			/>
			<SuperInput
				{form}
				{disabled}
				name="lastName"
				label="Last Name"
				autocomplete="family-name"
				required
			/>

			<SuperInput
				{form}
				{disabled}
				name="company"
				label="Company"
				class="col-span-full"
				autocomplete="organization"
			/>

			<SuperInput
				{form}
				{disabled}
				type="email"
				name="email"
				label="Email"
				autocomplete="email"
				class="col-span-full"
				required
			/>
			<SuperInput
				{form}
				{disabled}
				name="phone"
				type="tel"
				label="Phone"
				autocomplete="tel"
				phoneCountry="US"
				class="col-span-full"
			/>
			<SuperInput
				{form}
				{disabled}
				name="postalCode"
				type="text"
				label="Zip / Postal Code"
				autocomplete="postal-code"
			/>
			<Country {form} {disabled} name="country" label="Country" />

			<SuperInput
				{form}
				{disabled}
				name="notes"
				type="textarea"
				class="col-span-full"
				label="How can we help you? (optional)"
			/>
			<SuperInput
				{form}
				{disabled}
				name="windowCount"
				class="col-span-full"
				type="radio"
				label="Number of Windows"
				options={[
					{ label: '< 50', value: null },
					{ label: '50+', value: 50 },
				]}
			/>
		{/snippet}
	</SuperForm>
</div>
